import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Subscription } from './subscription';
import { Pagination } from '../../pagination';
import { environment } from '@env/environment';

@Injectable()
export class AdminSubscriptionProvider {

    constructor(private http: HttpClient) {}

    getSubscriptions(params: any): Observable<any> {
        const response = {
            meta: {},
            pagination: {},
            subscriptions: []
        };

        return this.http.get(`${environment.envVar.API_URL}/course-subscription-validations`, {params}).pipe(
            map((data: any) => {
                response.meta = data.meta;
                response.pagination = new Pagination(data.pagination);
                data.subscriptions.map((subscription) => {
                    response.subscriptions.push(new Subscription(subscription));
                });

                return response;
            })
        );
    }

    update(subscriptionId: number, params: any): Observable<any> {
        return this.http.put(`${environment.envVar.API_URL}/course-subscription-validations/${subscriptionId}`, params).pipe(
            map(data => data)
        );
    }
}
